import React from 'react';

/**
 * ConfidenceSlider Component
 * A reusable 1–10 slider designed for Gen Z touch targets.
 * Captures psychometric data for the "Confidence Index".
 */
export default function ConfidenceSlider({ value, onChange, title, subtitle }) {
  return (
    <div className="w-full py-6 px-4 bg-blue-50 rounded-2xl border border-blue-100 animate-fade-in">
      <div className="text-center mb-6">
        <h3 className="text-lg font-black text-blue-900 uppercase tracking-tight">{title}</h3>
        <p className="text-sm text-blue-700 font-medium">{subtitle}</p>
      </div>

      <div className="relative flex flex-col items-center">
        {/* Value Display */}
        <div className="mb-4 text-4xl font-black text-blue-600 bg-white w-16 h-16 flex items-center justify-center rounded-full shadow-lg border-2 border-blue-200">
          {value}
        </div>

        {/* Range Input */}
        <input
          type="range"
          min="1"
          max="10"
          step="1"
          value={value}
          onChange={(e) => onChange(parseInt(e.target.value))}
          className="w-full h-3 bg-blue-200 rounded-lg appearance-none cursor-pointer accent-blue-600"
        />

        {/* Labels */}
        <div className="w-full flex justify-between mt-4 px-1">
          <span className="text-[10px] font-bold text-blue-400 uppercase tracking-widest">Not Confident</span>
          <span className="text-[10px] font-bold text-blue-400 uppercase tracking-widest">Mastery</span>
        </div>
      </div>
    </div>
  );
}